const transformDate = (dateObj) => {
  if (!dateObj) return null
  const seconds = dateObj.seconds
  return seconds > 0 ? new Date(seconds * 1000) : null
}

const timestamp = () => new Date()

export {
  transformDate,
  timestamp
}
